/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Task } from './Task.js';
import {
    TaskFromJSON,
    TaskFromJSONTyped,
    TaskToJSON,
} from './Task.js';

/**
 * 
 * @export
 * @interface TasksListResponse
 */
export interface TasksListResponse {
    /**
     * 
     * @type {Array<Task>}
     * @memberof TasksListResponse
     */
    data?: Array<Task>;
    /**
     * 
     * @type {number}
     * @memberof TasksListResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof TasksListResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof TasksListResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof TasksListResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the TasksListResponse interface.
 */
export function instanceOfTasksListResponse(value: object): boolean {
    return true;
}

export function TasksListResponseFromJSON(json: any): TasksListResponse {
    return TasksListResponseFromJSONTyped(json, false);
}

export function TasksListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TasksListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(TaskFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function TasksListResponseToJSON(value?: TasksListResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(TaskToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

